<template>
  <div class="emtry-w x_y_center">
    <img src="@/assets/images/empty_icon.png" alt="" />
    <span style="margin: 0 0 0 10px">暂无数据</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.emtry-w {
  width: 100%;
  height: 100%;
  min-height: 100px;
}
</style>